<script>
import {
  uploadFiles,
  uploadApplication,
  getApplicationById,
  updateApplication,
  getApplicationByNetId,
  fileRootUrl,
  getInternships,
} from "../services/services";
import MessageDialog from "../components/MessageDialog";
import LSDatePicker from "../components/LSDatePicker.vue";
import { jsPDF } from "jspdf";

export default {
  name: "Apply",
  components: { MessageDialog, LSDatePicker },
  data() {
    return {
      application: {
        id: 0,
        firstName: "",
        lastName: "",
        netId: "",
        major: "",
        yearInSchool: "",
        gpa: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        citizenship: "Yes",
        fellowships: ["", "", ""],
        locationOfInternship: "",
        startDate: "",
        endDate: "",
        year: "",
        courseNumber: "",
        semester: "",
        department: "",
        resume: {},
        letter: {},
        professorSendSeperate: "No",
        researchExperience: "",
        careerAspirations: "",
        uniqueQualifications: "",
        digitalSignature: "",
        professorEmail: "",
      },
      applicationSubmitted: null,
      fileRootUrl: fileRootUrl(),
      citizenshipOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      panel: [0, 1],
      resume: {},
      letter: {},
      id: 0,
      thankYouNote: {},
      internships: [],
      states: [
        { label: "Alabama", value: "AL" },
        { label: "Alaska", value: "AK" },
        { label: "Arizona", value: "AZ" },
        { label: "Arkansas", value: "AR" },
        { label: "California", value: "CA" },
        { label: "Colorado", value: "CO" },
        { label: "Connecticut", value: "CT" },
        { label: "Delaware", value: "DE" },
        { label: "Florida", value: "FL" },
        { label: "Georgia", value: "GA}" },
        { label: "Hawaii", value: "HI" },
        { label: "Idaho", value: "ID" },
        { label: "Illinois", value: "IL" },
        { label: "Indiana", value: "IN" },
        { label: "Iowa", value: "IA" },
        { label: "Kansas", value: "KS" },
        { label: "Kentucky", value: "KY" },
        { label: "Louisiana", value: "LA" },
        { label: "Maine", value: "ME" },
        { label: "Maryland", value: "MD" },
        { label: "Massachusetts", value: "MA" },
        { label: "Michigan", value: "MI" },
        { label: "Minnesota", value: "MN" },
        { label: "Mississippi", value: "MS" },
        { label: "Missouri", value: "MO" },
        { label: "Montana", value: "MT" },
        { label: "Nebraska", value: "NE" },
        { label: "Nevada", value: "NV" },
        { label: "New Hampshire", value: "NH" },
        { label: "New Jersey", value: "NJ" },
        { label: "New Mexico", value: "NM" },
        { label: "New York", value: "NY" },
        { label: "North Carolina", value: "NC" },
        { label: "North Dakota", value: "ND" },
        { label: "Ohio", value: "OH" },
        { label: "Oklahoma", value: "OK" },
        { label: "Oregon", value: "OR" },
        { label: "Pennsylvania", value: "PA" },
        { label: "Rhode Island", value: "RI" },
        { label: "South Carolina", value: "SC" },
        { label: "South Dakota", value: "SD" },
        { label: "Tennessee", value: "TN" },
        { label: "Texas", value: "TX" },
        { label: "Utah", value: "UT" },
        { label: "Vermont", value: "VT" },
        { label: "Virginia", value: "VA" },
        { label: "Washington", value: "WA" },
        { label: "West Virginia", value: "WV" },
        { label: "Wisconsin", value: "WI" },
        { label: "Wyoming", value: "WY" },
      ],
      rules: {
        required: (value) => !!value || "This field is required.",
        email: (value) => {
          //this.studentProfile.email = value;
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Email.";
        },
        phoneNumber: (value) => {
          const pattern =
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
          return (
            pattern.test(value) ||
            "Invalid phone number (ex. (123)456-7890, 111-111-1111, or 1234567890)"
          );
        },
        requiredZip: (value) => {
          const pattern = /d+/;
          if (value != undefined || value != null) {
            return (
              (value === 5 && pattern.test(value)) ||
              "This field requires 5 numbers."
            );
          } else {
            return true;
          }
        },
        requiredGPA: (value) => {
          if (value != undefined || value != null) {
            if (value.length === 4) {
              if (
                parseInt(value.substring(0, 1)) >= 4 &&
                parseInt(value.substring(2)) > 0
              ) {
                return "GPA cannot be greater than 4.00";
              } else {
                return true;
              }
            } else {
              return "This field requires a format of #.##";
            }
          } else {
            return true;
          }
        },
      },
      viewingFromSubmissionsPage: false,
    };
  },
  mounted() {
    // get Internship data for v-select.
    getInternships().then((data) => {
      this.internships = data;
    });
    // set netId if logged in.
    this.application.netId = this.$store.state.User.netId;
    // set query for submissions page
    const id = this.$route.query.id;
    // get Application by Id if coming from submissions page
    if (!!id) {
      this.id = id;
      this.viewingFromSubmissionsPage = true;
      this.applicationSubmitted = false; //this doesn't make sense by variable name, but this line is used to fix page flicker on load. don't remove it or things break.

      getApplicationById(id).then((data) => {
        const app = { ...data };
        app.citizenship = data.usCitizen ? "Yes" : "No";
        app.fellowships = data.sitesApplying.split(",");
        app.startDate = new Date(app.startDate).toLocaleDateString();
        app.endDate = new Date(app.endDate).toLocaleDateString();
        app.professorSendSeperate = data.recommendationSentSeperate
          ? "My Professor will send my letter"
          : "I will upload the letter";
        
if (app.professorEmail) {
          app.professorSendSeperate = "My Professor will send my letter";
        }
        this.application = app;
        // console.log(this.application);
        if (this.application.professorEmail) {
          this.application.professorSendSeperate =
            "My Professor will send my letter";
        }
      });
      // get application by netId if logged in and is saved.
    } else {
      getApplicationByNetId(this.$store.state.User.netId)
        .then((data) => {
          if (!data.dateSubmitted) {
            this.applicationSubmitted = false;
          }
          const app = { ...data };
          app.citizenship = data.usCitizen ? "Yes" : "No";
          app.fellowships = data.sitesApplying.split(", ");
          app.recommendationSentSeperate = data.recommendationSentSeperate
            ? "My Professor will send my letter"
            : "I will upload the letter";
          if (app.professorEmail) {
            app.professorSendSeperate = "My Professor will send my letter";
          }

          this.application = app;
          const year = new Date().getFullYear();
          if (this.application.dateSubmitted.substring(0, 4) == year) {
            this.applicationSubmitted = true;
          }

          if (this.application.professorEmail) {
            this.application.professorSendSeperate =
              "My Professor will send my letter";
          }
        })
        .catch((err) => {
          this.applicationSubmitted = false;
        });
    }
  },
  computed: {
    startYear() {
      const NOW = new Date();
      return NOW.getFullYear();
    },
  },
  methods: {
    save() {
      this.application.sitesApplying = this.application.fellowships.join(", ");
      const toSend = { ...this.application };
      try {
        if (this.application.id) {
          updateApplication(toSend).then((data) => {
            this.uploadFiles();
            alert("Your application has been saved.");
          });
        } else {
          uploadApplication(toSend).then((data) => {
            this.application.id = data.id;
            this.uploadFiles();
            alert("Your application has been saved.");
          });
        }
      } catch (error) {
        console.log(error);
        alert("Your application failed to save.");
      }
    },

    uploadFiles() {
      const form = new FormData();

      if (!this.resume && !this.letter && !this.thankYouNote) return;

      if (!!this.resume) {
        form.append(`r-${this.resume.name}`, this.resume);
      }
      if (!!this.application.letter) {
        form.append(
          `l-${this.application.letter.name}`,
          this.application.letter
        );
      }
      if (!!this.thankYouNote) {
        form.append(`t-${this.thankYouNote.name}`, this.thankYouNote);
      }

      const resp = uploadFiles(form, this.application.id);
    },

    submit() {
      const toSend = { ...this.application };
      toSend.dateSubmitted = new Date();
      try {
        if (this.application.id) {
          updateApplication(toSend).then((data) => {
            this.uploadFiles();
            alert("Your application has been submitted.");
          });
        } else {
          uploadApplication(toSend).then((data) => {
            this.application.id = data.id;
            this.uploadFiles();
            alert("Your application has been submitted.");
          });
        }
        this.$router.push({
          path: "/",
        });
      } catch (error) {
        console.log(error);
        alert("Your application failed to submit.");
      }
    },
    quickSubmit() {
      this.application = {
        firstName: "Test",
        lastName: "Test",
        major: "Test",
        yearInSchool: "Senior",
        phoneNumber: "1234567890",
        email: "test@test.com",
        gpa: "4.00",
        address: "a",
        city: "a",
        state: "UT",
        zip: "84604",
        usCitizen: true,
        fellowships: [
          "Washington University - St. Louis",
          "Center for Genomic Interpretation",
          "University of California - San Diego (Lewis Labs)",
        ],
        startDate: "2021-11-05T00:00:00",
        endDate: "2021-11-05T00:00:00",
        year: 1,
        courseNumber: "test",
        department: "Biology",
        semester: "Fall",
        uniqueQualifications: "a",
        digitalSignature: "a",
        careerAspirations: "a",
        locationOfInternship: "a",
        researchExperience: "a",
        otherFunding: "a",
        professorEmail: "jjh123@ls.byu.edu",
        professorSendSeperate: true,
        netId: this.$store.state.User.netId,
      };
    },
    clearOtherValue(item) {
      if (item == "I will upload the letter") {
        this.application.professorEmail = "";
      }
    },
  },

  watch: {
    application(val) {
      (this.application.uscitizen =
        this.application.citizenship === "Yes" ? true : false),
        (this.application.sitesApplying =
          this.application.fellowships.join(", ")),
        (this.application.recommendationSentSeperate =
          this.application.professorSendSeperate ===
          "My Professor will send my letter"
            ? true
            : false);
      this.resume = {
        name: val.resume.fileName,
      };
      this.thankYouNote = {
        name: val.thankYouLetter.fileName,
      };
      this.letter = {
        name: val.letterOfReccomendation.fileName,
      };
    },
  },
};
</script>

<template>
  <v-layout column>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>Duties</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Duties and expectations vary widely among internships. Students can be
          involved in any part of the research project: literature review,
          creation of hypotheses, study development and implementation, data
          collection, data analysis, and presentation and dissemination of
          findings.
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>Timeline</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li>January 15th: Internship applications are due.</li>
            <li>
              January 15th-January 30th: Upon receipt of applications, the
              College of Life Sciences will competitively select the top
              applicants for each internship site. The college then reports the
              top applicants to the internship lab directors.
            </li>
            <li>
              January 30-April 15: Internship lab directors select their top
              applicants.
            </li>
            <ul>
              <li>
                Students accepted at those sites will have access to the
                internship fellowship to help pay for your experience at those
                sites.
              </li>
              <li>
                Students may expect to be notified by late February through
                April.
              </li>
            </ul>
            <li>
              April 15-May 15: Internships start by early May and end in August
              and vary widely based on the individual and the lab/primary
              investigator
            </li>
            <li>If you have any questions please email lsinternships@byu.edu</li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <br />
    <div v-if="!viewingFromSubmissionsPage && applicationSubmitted">
      <center>
        <h2>Your application is submitted.</h2>
      </center>
    </div>
    <div v-else-if="applicationSubmitted == false">
      <h1 style="padding-bottom: 16px">Personal Information</h1>
      <v-btn v-if="this.$store.state.User.roleID == 1" @click="quickSubmit"
        >Fill Out</v-btn
      >
      <router-link :to="'export?id=' + application.id" target="_blank">
      <v-btn v-if="this.$store.state.User.roleID == 1"
        >View PDF</v-btn
      >
    </router-link>
      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-text-field
            outlined
            label="First Name"
            v-model="application.firstName"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            outlined
            label="Last Name"
            v-model="application.lastName"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-right: 16px" md6>
          <v-text-field
            outlined
            label="NetID"
            v-model="application.netId"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex md6>
          <v-select
            outlined
            label="Year In School"
            v-model="application.yearInSchool"
            :rules="[rules.required]"
            :items="['Freshman', 'Sophomore', 'Junior', 'Senior']"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-text-field
            outlined
            label="Major"
            v-model="application.major"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            outlined
            label="GPA"
            v-model="application.gpa"
            :rules="[rules.requiredGPA]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-text-field
            outlined
            label="Phone Number"
            v-model="application.phoneNumber"
            :rules="[rules.required, rules.phoneNumber]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            outlined
            label="Email"
            v-model="application.email"
            :rules="[rules.required, rules.email]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-text-field
            outlined
            label="Mailing Address"
            v-model="application.address"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-text-field
            outlined
            label="City"
            v-model="application.city"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex style="padding-right: 16px">
          <v-autocomplete
            v-model="application.state"
            label="State"
            outlined
            item-value="value"
            item-text="label"
            required
            :menu-props="{ top: true, offsetY: true }"
            :items="states"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex>
          <v-text-field
            outlined
            label="Zip Code"
            v-model="application.zip"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <h1 style="padding-bottom: 16px">Academic Information</h1>
      <v-layout>
        <v-flex style="padding-right: 16px" md6>
          <v-select
            outlined
            label="Are you a United States citizen?"
            v-model="application.usCitizen"
            :items="citizenshipOptions"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex style="padding-bottom: 16px">
          For which inspired learning fellowship(s) are you applying? (Max 3) If
          you would like to apply for more than one internship, please list in
          ranked order, one being the most desired.
        </v-flex>
      </v-layout>
      <v-layout>
        <v-layout
          v-for="(f, i) in application.fellowships"
          :key="i + '-ksnd'"
          align-center
        >
          <v-select
            v-if="!viewingFromSubmissionsPage"
            outlined
            v-model="application.fellowships[i]"
            :items="internships"
            item-text="name"
            :label="'Fellowship ' + (i + 1)"
            :style="i < 2 ? 'padding-right: 16px' : ''"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
          <v-text-field
            v-else
            outlined
            v-model="application.fellowships[i]"
            :label="'Fellowship ' + (i + 1)"
            :style="i < 2 ? 'padding-right: 16px' : ''"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-layout>
      </v-layout>
      <!-- <v-layout>
        <v-flex>
          <v-text-field
            label="Internship Location"
            v-model="application.locationOfInternship"
            outlined
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
      </v-layout> -->
      <v-layout>
        <v-flex md6 style="padding-right: 16px">
          <LSDatePicker
            v-if="!viewingFromSubmissionsPage"
            :startYear="startYear"
            :endYear="startYear + 10"
            v-model="application.startDate"
            title="Start Date"
          ></LSDatePicker>
          <v-text-field
            v-else
            outlined
            readonly
            label="End date"
            v-model="application.startDate"
          ></v-text-field>
        </v-flex>
        <v-flex md6>
          <LSDatePicker
            v-if="!viewingFromSubmissionsPage"
            :startYear="startYear + 1"
            :endYear="startYear + 11"
            title="End Date"
            v-model="application.endDate"
          ></LSDatePicker>
          <v-text-field
            v-else
            outlined
            readonly
            label="End date"
            v-model="application.endDate"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md6 style="padding-right: 16px">
          <v-text-field
            outlined
            label="Year"
            v-model="application.year"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex md6>
          <v-select
            :items="[
              'Biology',
              'Exercise Sciences',
              'Microbiology and Moleculary Biology',
              'Nutrition, Dietetics and Food Science',
              'Physiology and Developmental Biology',
              'Plant and Wildlife Sciences',
              'Public Health',
            ]"
            outlined
            label="Department"
            v-model="application.department"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md6 style="padding-right: 16px">
          <v-text-field
            outlined
            label="Course Number"
            v-model="application.courseNumber"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-text-field>
        </v-flex>
        <v-flex md6>
          <v-select
            :items="['Fall', 'Winter', 'Spring/Summer']"
            outlined
            label="Semester"
            v-model="application.semester"
            :rules="[rules.required]"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout style="padding-bottom: 16px">
        To qualify for the fellowship you must have a letter of recommendation
        from one current faculty member with whom you have done research. You
        can either upload it here, or have the faculty member email it to
        michael_stark@byu.edu.
      </v-layout>
      <v-layout
        v-if="
          application.professorSendSeperate ===
          'My Professor will send my letter'
        "
      >
        <v-flex
          v-if="!viewingFromSubmissionsPage"
          id="professor-email-warning-container"
        >
          <p id="professor-email-warning">
            It is your responsibility to make sure your professor sends in a
            recommendation.
          </p>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md6>
          <v-select
            :items="[
              'My Professor will send my letter',
              'I will upload the letter',
            ]"
            @input="clearOtherValue"
            outlined
            label="Letter upload options"
            :rules="[rules.required]"
            v-model="application.professorSendSeperate"
            :readonly="viewingFromSubmissionsPage"
          ></v-select>
        </v-flex>
        <v-flex md6>
          <v-file-input
            v-if="
              !viewingFromSubmissionsPage &&
              application.professorSendSeperate === 'I will upload the letter'
            "
            outlined
            label="Letter of Recommendation"
            v-model="application.letter"
            :disabled="viewingFromSubmissionsPage"
          ></v-file-input>
          <v-text-field
            class="ml-2"
            v-if="
              application.professorSendSeperate ===
                'My Professor will send my letter' || application.professorEmail
            "
            label="Professor Email"
            v-model="application.professorEmail"
            outlined
            :readonly="viewingFromSubmissionsPage"
            :rules="[rules.email]"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex style="padding-right: 16px">
          <v-file-input
            v-if="!viewingFromSubmissionsPage"
            outlined
            label="Resume"
            v-model="resume"
            :disabled="viewingFromSubmissionsPage"
            :rules="[rules.required]"
          ></v-file-input>
          <v-btn
            v-if="
              viewingFromSubmissionsPage && application.resume.fileName != null
            "
            class="ml-12 mt-2 mb-6"
            color="primary"
          >
            <a
              v-if="viewingFromSubmissionsPage"
              :href="
                fileRootUrl +
                '/resume/' +
                application.resume.applicationId +
                '/r-' +
                application.resume.fileName
              "
              target="_blank"
              class="fileLink"
              >View resume</a
            >
          </v-btn>
        </v-flex>
        <v-flex>
          <v-file-input
            v-if="!viewingFromSubmissionsPage"
            outlined
            label="Thank You Note"
            v-model="thankYouNote"
            :rules="[rules.required]"
            :disabled="viewingFromSubmissionsPage"
          ></v-file-input>
          <v-btn
            v-if="
              viewingFromSubmissionsPage &&
              application.thankYouLetter.fileName != null
            "
            class="ml-12 mt-2 mb-6"
            color="primary"
          >
            <a
              v-if="viewingFromSubmissionsPage"
              :href="
                fileRootUrl +
                '/ThankYou/' +
                application.thankYouLetter.applicationId +
                '/t-' +
                application.thankYouLetter.fileName
              "
              target="_blank"
              class="fileLink"
              >View thank you letter</a
            >
          </v-btn>
        </v-flex>
        <v-flex v-if="viewingFromSubmissionsPage">
          <v-btn
            class="ml-12 mt-2 mb-6"
            color="primary"
            v-if="application.letterOfReccomendation.fileName != null"
          >
            <a
              :href="
                fileRootUrl +
                '/letter/' +
                application.letterOfReccomendation.applicationId +
                '/l-' +
                application.letterOfReccomendation.fileName
              "
              target="_blank"
              class="fileLink"
              >View letter of recommendation</a
            >
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout style="padding-bottom: 16px">
        <div>
          Each fellowship is funded by donors who are anxious to support elite
          student research internships. Express your sincere appreciation and
          include:
          <ul>
            <li>The goals of your research</li>
            <li>
              Your educational or professional plans following the fellowship
            </li>
            <li>How the fellowship will help you achieve those goals</li>
            <li>A picture of yourself</li>
          </ul>
        </div>
      </v-layout>

      <v-textarea
        outlined
        label="Research Experience"
        v-model="application.researchExperience"
        :rules="[rules.required]"
        :readonly="viewingFromSubmissionsPage"
      ></v-textarea>
      <v-textarea
        outlined
        label="School Career Aspirations"
        v-model="application.careerAspirations"
        :rules="[rules.required]"
        :readonly="viewingFromSubmissionsPage"
      ></v-textarea>
      <v-textarea
        outlined
        label="Unique Qualifications"
        v-model="application.uniqueQualifications"
        :rules="[rules.required]"
        :readonly="viewingFromSubmissionsPage"
      ></v-textarea>

      <div style="padding-bottom: 8px">
        List all current or anticipated scholarships, assistantships,
        fellowships, grants, or any other sources of funding you will have
        during this fellowship.
      </div>
      <v-textarea
        outlined
        v-model="application.otherFunding"
        :rules="[rules.required]"
        :readonly="viewingFromSubmissionsPage"
      ></v-textarea>

      <v-layout column>
        <div style="padding-bottom: 16px; font-weight: bold">
          I certify that this application is truthful and as accurate as I can
          make it. I certify that the application is entirely of my own creation
          and writing. Any assistance from others is limited to minor editorial
          correction.
        </div>
        <v-text-field
          outlined
          label="Digital Signature"
          v-model="application.digitalSignature"
          :rules="[rules.required]"
          :readonly="viewingFromSubmissionsPage"
        ></v-text-field>
      </v-layout>
      <v-layout v-if="!viewingFromSubmissionsPage" justify-end>
        <v-btn color="secondary" @click="save">Save</v-btn>
        <div style="width: 8px"></div>
        <v-btn color="primary" @click="submit">Submit</v-btn>
      </v-layout>
    </div>
  </v-layout>
</template>

<style scoped>
#add-new-fellowship {
  height: 54px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  transition: 0.2s;
  display: flex;
  align-items: center;
  padding-left: 12px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.42);
}
#add-new-fellowship:hover {
  border-color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
}
.fileLink {
  color: white;
  text-decoration: none;
}
#professor-email-warning-container {
  width: 100%;
  padding-top: -45px !important;
}
#professor-email-warning {
  margin-left: 52%;
  color: #b71c1c;
}
</style>
